module.exports = __webpack_public_path__ + "static/media/31JFA1.717a2886.jpg";